import { Controller } from 'stimulus';

export default class extends Controller {
  //static targets = ['changeset', 'whodunnit', 'created_at'];
  static targets = [];
  connect() {
  }

  async fetchStream(event) {
    const id = event.currentTarget.dataset.id;
    const response = await fetch('/admin/streams/' + id + ".json");
    const data = await response.json();

    $("#streamHistoryContent").html(data.changeset);
  }
  
}